import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { CommonConstants } from '../utilities/commonConstants';
import { ConfigService } from './config.service';
import { HttpInterceptor } from './httpInterceptor.service';

@Injectable({
  providedIn: 'root'
})
export class AppIdleService {

  private timer;
  private idleTimeoutMilliseconds: number;
  private idleSubscription: Subscription;

  public expired$: Subject<boolean> = new Subject<boolean>();
  constructor(private _httpInterceptor: HttpInterceptor) {
    // calculated idle timeout value in milliseconds
    this.idleTimeoutMilliseconds = ((CommonConstants.appIdleTimeout * 60000) - 40000);
    // for development only
    // this.idleTimeoutMilliseconds = 30000;
  }

  public startTimer() {
    this.timer = setTimeout(() => {
      this.expired$.next(true);
    }, this.idleTimeoutMilliseconds);
  }

  public resetTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.startTimer();
  }

  public stopTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  public ExtendSessionSerive(requestData) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.sessionExtendService;
    url = url.replace('{applicationId}', requestData.payload.applicationId);
    return this._httpInterceptor.Post(url, {});
  }
}
